import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import get from 'lodash.get'

const getInfoWindow = gql`
mutation GetInfoWindow ($varCamada: String! $x: Float! $y: Float!){
  getInfowindow(input: {
    varCamada: $varCamada,
    x: $x,
    y: $y
  }) {
    json
  }
}
`

const getInfoWindowOptions = {
  props: ({ mutate }) => ({
    async getInfoWindow ({ lat, lng }, layer) {
      const options = {
        variables: {
          varCamada: layer,
          x: lng * 100000,
          y: lat * 100000
        }
      }

      const response = await mutate(options)

      // return get(response, 'data.getInfowindow.json', {})
      return get(response, 'data', {})
    }
  })
}

export default graphql(getInfoWindow, getInfoWindowOptions)



// WEBPACK FOOTER //
// ./src/components/pages/Mapa/Mapa.getInfoWindow.js